import { lazy } from 'react';
export const ResearchPage = lazy(() => import(/* webpackChunkName: "study" */ '.'));
export default ResearchPage;
